import { render, staticRenderFns } from "./204.vue?vue&type=template&id=0dc2421a&scoped=true&"
import script from "./204.vue?vue&type=script&lang=js&"
export * from "./204.vue?vue&type=script&lang=js&"
import style0 from "./204.vue?vue&type=style&index=0&id=0dc2421a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc2421a",
  null
  
)

export default component.exports